import { useNavigate } from 'react-router-dom';

function LinkBtn({ onClick, children, estilo }) {
  return (
    <button style={estilo} onClick={onClick}>{children}</button>
  );
}

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div style={styles.pagina}>

      {/* ── NAVBAR ── */}
      <nav style={styles.nav}>
        <div style={styles.navLogo}>
          Tu<span style={styles.naranja}>Rival</span>
        </div>
        <div style={styles.navLinks}>
          <button style={styles.navLinkBtn} onClick={() => navigate('/app/recintos')}>Recintos</button>
          <button style={styles.navLinkBtn} onClick={() => navigate('/app/arbitros')}>Árbitros</button>
          <button style={styles.navLinkBtn} onClick={() => navigate('/app/tercer-tiempo')}>Tercer Tiempo</button>
          <button style={styles.btnNavLogin} onClick={() => navigate('/login')}>Iniciar sesión</button>
          <button style={styles.btnNavRegistro} onClick={() => navigate('/registro')}>Registrar equipo</button>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          <div style={styles.heroBadge}>🇨🇱 Lanzando en Machalí · O'Higgins</div>
          <h1 style={styles.heroTitulo}>
            El deporte amateur<br />
            merece organización<br />
            <span style={styles.naranja}>profesional</span>
          </h1>
          <p style={styles.heroSub}>
            TuRival conecta equipos de fútbol y pádel amateur, recintos
            deportivos, árbitros y proveedores de Tercer Tiempo en una
            sola plataforma. Desafía, juega y celebra juntos.
          </p>
          <div style={styles.heroBotones}>
            <button style={styles.btnHeroPrimario} onClick={() => navigate('/registro')}>
              Registrar mi equipo gratis →
            </button>
            <button style={styles.btnHeroSecundario} onClick={() => navigate('/login')}>
              Ya tengo cuenta
            </button>
          </div>
          <div style={styles.heroStats}>
            {[
              { n: '800',   l: 'ELO inicial'       },
              { n: '$0',    l: 'Para empezar'       },
              { n: '5 min', l: 'Para registrarse'   },
            ].map(({ n, l }, i) => (
              <div key={l} style={styles.heroStatWrap}>
                {i > 0 && <div style={styles.heroStatDiv} />}
                <div style={styles.heroStat}>
                  <div style={styles.heroStatNum}>{n}</div>
                  <div style={styles.heroStatLabel}>{l}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Preview app */}
        <div style={styles.heroPreview}>
          <div style={styles.previewCard}>
            <div style={styles.previewHeader}>
              {['EF4444','F59E0B','16A34A'].map(c => (
                <div key={c} style={{ ...styles.previewDot, background: '#' + c }} />
              ))}
            </div>
            <div style={styles.previewEquipo}>
              <div style={styles.previewEscudo}>LB</div>
              <div style={{ flex: 1 }}>
                <div style={styles.previewNombre}>Los Bombarderos FC</div>
                <div style={styles.previewZona}>Machalí · Fútbol 7</div>
              </div>
              <div style={styles.previewEloWrap}>
                <div style={styles.previewEloNum}>840</div>
                <div style={styles.previewEloLabel}>ELO</div>
              </div>
            </div>
            <div style={styles.previewStats}>
              {[['12','Partidos'],['8','Victorias'],['#3','Ranking']].map(([n, l]) => (
                <div key={l} style={styles.previewStat}>
                  <div style={styles.previewStatN}>{n}</div>
                  <div style={styles.previewStatL}>{l}</div>
                </div>
              ))}
            </div>
            <div style={styles.previewDesafio}>
              <div style={styles.previewDesafioTxt}>⚡ Desafío recibido</div>
              <div style={styles.previewDesafioRival}>Gladiadores del Sur · ELO 1190</div>
              <div style={styles.previewDesafioBtns}>
                <div style={styles.previewBtnRechazar}>Rechazar</div>
                <div style={styles.previewBtnAceptar}>⚡ Aceptar</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── EL PROBLEMA ── */}
      <section style={styles.seccionOscura}>
        <div style={styles.inner}>
          <div style={styles.badge}>El problema</div>
          <h2 style={styles.seccionTitulo}>¿Cansado de organizar partidos por WhatsApp?</h2>
          <div style={styles.grid4}>
            {[
              { icono: '😤', titulo: 'Ausentismo',       desc: 'El rival confirma y no llega. Perdiste la cancha, el árbitro y el tiempo de todos.' },
              { icono: '📱', titulo: 'Caos en WhatsApp', desc: 'Coordinar fecha, hora, cancha y árbitro en múltiples grupos distintos es un caos.' },
              { icono: '🏆', titulo: 'Sin ranking',      desc: 'No hay forma de saber qué equipos son realmente de tu nivel.' },
              { icono: '📊', titulo: 'Sin historial',    desc: 'Tus resultados y el rendimiento del equipo se pierden con el tiempo.' },
            ].map(({ icono, titulo, desc }) => (
              <div key={titulo} style={styles.problemaCard}>
                <div style={styles.problemaIcono}>{icono}</div>
                <div style={styles.problemaTitulo}>{titulo}</div>
                <div style={styles.problemaDesc}>{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CÓMO FUNCIONA ── */}
      <section style={styles.seccionMedia}>
        <div style={styles.inner}>
          <div style={styles.badge}>Cómo funciona</div>
          <h2 style={styles.seccionTitulo}>Del desafío al partido en 3 pasos</h2>
          <div style={styles.grid3}>
            {[
              { num: '01', icono: '👥', titulo: 'Registra tu equipo',  desc: 'Crea el perfil de tu equipo en menos de 5 minutos. Agrega a tus jugadores, elige tu zona y modalidad deportiva.' },
              { num: '02', icono: '⚡', titulo: 'Desafía o acepta',    desc: 'Encuentra rivales compatibles por ELO, zona y edad promedio. El sistema calcula automáticamente qué tan parejo será el partido.' },
              { num: '03', icono: '🏆', titulo: 'Juega y crece',       desc: 'El depósito garantiza que ambos equipos llegan. Al terminar evalúas al rival y tu ELO se actualiza automáticamente.' },
            ].map(({ num, icono, titulo, desc }, i) => (
              <div key={num} style={styles.pasoCard}>
                <div style={styles.pasoNum}>{num}</div>
                <div style={styles.pasoIcono}>{icono}</div>
                <div style={styles.pasoTitulo}>{titulo}</div>
                <div style={styles.pasoDesc}>{desc}</div>
                {i < 2 && <div style={styles.pasoFlecha}>→</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ECOSISTEMA ── */}
      <section style={styles.seccionOscura}>
        <div style={styles.inner}>
          <div style={styles.badge}>El ecosistema</div>
          <h2 style={styles.seccionTitulo}>Más que una app de partidos</h2>
          <p style={styles.seccionSub}>
            TuRival conecta a todos los actores del deporte amateur en una sola plataforma.
          </p>
          <div style={styles.grid4}>
            {[
              { icono: '⚽', titulo: 'Equipos',       color: '#1A6BFF', desc: 'Perfil público con ELO, historial y evaluaciones de rivales.', btn: 'Registrar equipo',   ruta: '/registro' },
              { icono: '🏟️', titulo: 'Recintos',      color: '#16A34A', desc: 'Expón tu calendario y recibe reservas de equipos activos.', btn: 'Registrar recinto',  ruta: '/registro-recinto' },
              { icono: '🟡', titulo: 'Árbitros',      color: '#F59E0B', desc: 'Gestiona disponibilidad y recibe contrataciones directas.', btn: 'Registrarme',         ruta: '/registro-arbitro' },
              { icono: '🍺', titulo: 'Tercer Tiempo', color: '#FF6B1A', desc: 'Ofrece asados, cervezas y empanadas post partido.',         btn: 'Registrar negocio',  ruta: '/registro-tercer-tiempo' },
            ].map(({ icono, titulo, color, desc, btn, ruta }) => (
              <div key={titulo} style={styles.ecosistemaCard}>
                <div style={{ ...styles.ecosistemaIcono, background: color + '22' }}>{icono}</div>
                <div style={{ ...styles.ecosistemaTitulo, color }}>{titulo}</div>
                <div style={styles.ecosistemaDesc}>{desc}</div>
                <button
                  style={{ ...styles.ecosistemaBtn, color, borderColor: color }}
                  onClick={() => navigate(ruta)}
                >
                  {btn} →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SISTEMA ELO ── */}
      <section style={styles.seccionMedia}>
        <div style={styles.inner}>
          <div style={styles.eloGrid}>
            <div style={styles.eloInfo}>
              <div style={styles.badge}>Sistema ELO</div>
              <h2 style={styles.seccionTitulo}>Un ranking justo basado en resultados reales</h2>
              <p style={styles.eloTexto}>
                Cada equipo parte con 800 puntos. Ganar sube tu ELO, perder lo baja.
                Ganar contra equipos más fuertes da más puntos. El ranking es
                transparente y se actualiza en tiempo real.
              </p>
              <div style={styles.eloCaracts}>
                {[
                  'ELO inicial 800 para todos los equipos nuevos',
                  'Se actualiza automáticamente después de cada partido',
                  'Ranking por zona y modalidad deportiva',
                  'Historial completo de partidos y evolución del ELO',
                ].map(c => (
                  <div key={c} style={styles.eloCaract}>
                    <div style={styles.eloCaractDot} />
                    <span>{c}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={styles.eloRankingCard}>
              <div style={styles.eloRankingTitle}>RANKING MACHALÍ · FÚTBOL 7</div>
              {[
                { pos: '1', ini: 'LF', nombre: 'Los Fieras de Machalí', elo: 1380, c1: '#F59E0B', c2: '#D97706' },
                { pos: '2', ini: 'AC', nombre: 'Atlético Cachapoal',    elo: 1310, c1: '#EF4444', c2: '#B91C1C' },
                { pos: '3', ini: 'LB', nombre: 'Los Bombarderos FC',    elo: 1240, c1: '#FF6B1A', c2: '#1A6BFF', yo: true },
                { pos: '4', ini: 'GS', nombre: 'Gladiadores del Sur',   elo: 1190, c1: '#1A6BFF', c2: '#0F4FCC' },
                { pos: '5', ini: 'CF', nombre: 'Cóndores FC',           elo: 1180, c1: '#7C3AED', c2: '#5B21B6' },
              ].map(r => (
                <div key={r.pos} style={{
                  ...styles.eloRankRow,
                  background: r.yo ? 'rgba(26,107,255,0.12)' : 'transparent',
                  borderRadius: r.yo ? 8 : 0,
                }}>
                  <div style={styles.eloRankPos}>{r.pos}</div>
                  <div style={{
                    ...styles.eloRankCrest,
                    background: `linear-gradient(135deg, ${r.c1}, ${r.c2})`,
                  }}>
                    {r.ini}
                  </div>
                  <div style={{
                    ...styles.eloRankNombre,
                    color: r.yo ? '#1A6BFF' : 'white',
                    fontWeight: r.yo ? 800 : 500,
                  }}>
                    {r.nombre}
                    {r.yo && <span style={styles.tuBadge}> Tú</span>}
                  </div>
                  <div style={styles.eloRankElo}>{r.elo}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── DEPÓSITO Y AUSENTISMO ── */}
      <section style={styles.seccionOscura}>
        <div style={styles.inner}>
          <div style={styles.badge}>Depósito de garantía</div>
          <h2 style={styles.seccionTitulo}>El ausentismo tiene consecuencias</h2>
          <div style={styles.ausentismoExplicacion}>
            <p style={styles.ausentismoTexto}>
              <strong style={{ color: 'white' }}>¿Qué es el ausentismo?</strong>
              {' '}Es cuando un equipo confirma un partido y simplemente no llega.
              En el deporte amateur es el problema más frecuente — pierdes la cancha,
              el árbitro y el tiempo de todos los jugadores.
            </p>
            <p style={styles.ausentismoTexto}>
              <strong style={{ color: '#FF6B1A' }}>¿Cómo funciona el depósito en TuRival?</strong>
              {' '}Cuando ambos equipos aceptan el desafío, cada uno realiza una transferencia
              a TuRival. Este monto cubre la reserva de la cancha y el árbitro si fue
              solicitado. El dinero queda retenido en TuRival hasta que el partido se juega.
              Si ambos llegan, se destina a pagar los servicios. Si uno no llega,
              el que sí llegó recupera su depósito completo.
            </p>
          </div>
          <div style={styles.grid3}>
            {[
              { icono: '✓', color: '#16A34A', titulo: 'Ambos llegan',      desc: 'El depósito se destina automáticamente a pagar los servicios contratados — cancha y árbitro.' },
              { icono: '✓', color: '#16A34A', titulo: 'El rival no llega', desc: 'Recuperas tu depósito completo. Tu tiempo y tu cancha tienen valor en TuRival.' },
              { icono: '✗', color: '#EF4444', titulo: 'Tú no llegas',      desc: 'Pierdes tu depósito y tu ELO baja. El compromiso con el deporte es real en TuRival.' },
            ].map(({ icono, color, titulo, desc }) => (
              <div key={titulo} style={styles.garantiaCard}>
                <div style={{ ...styles.garantiaIcono, color, borderColor: color }}>{icono}</div>
                <div style={styles.garantiaTitulo}>{titulo}</div>
                <div style={styles.garantiaDesc}>{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EVALUACIONES ── */}
      <section style={styles.seccionMedia}>
        <div style={styles.inner}>
          <div style={styles.badge}>Evaluaciones</div>
          <h2 style={styles.seccionTitulo}>Al terminar el partido, los equipos se evalúan mutuamente</h2>
          <p style={styles.seccionSub}>
            La reputación de un equipo se construye partido a partido.
            Cada evaluación queda visible en el perfil público para que
            otros rivales sepan con quién están jugando.
          </p>
          <div style={styles.grid4}>
            {[
              { icono: '⏰', titulo: 'Puntualidad',    desc: '¿El equipo llegó a la hora acordada? El respeto por el tiempo de todos es fundamental.' },
              { icono: '🤝', titulo: 'Comportamiento', desc: '¿Jugaron con respeto dentro y fuera de la cancha? Fair play y actitud deportiva.' },
              { icono: '😊', titulo: 'Buen ambiente',  desc: '¿Fue un partido de buen ánimo? La competencia sana hace crecer al deporte.' },
              { icono: '📋', titulo: 'Organización',   desc: '¿Vinieron con equipo completo y coordinados? Un equipo organizado hace mejor el partido.' },
            ].map(({ icono, titulo, desc }) => (
              <div key={titulo} style={styles.evalCard}>
                <div style={styles.evalIcono}>{icono}</div>
                <div style={styles.evalTitulo}>{titulo}</div>
                <div style={styles.evalDesc}>{desc}</div>
                <div style={styles.evalBarra}>
                  <div style={{ ...styles.evalBarraFill, width: '80%' }} />
                </div>
              </div>
            ))}
          </div>
          <div style={styles.evalNota}>
            💡 Las evaluaciones son visibles en el perfil público del equipo —
            la reputación se construye con cada partido jugado.
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section style={styles.ctaSeccion}>
        <div style={styles.ctaInner}>
          <div style={styles.ctaLogo}>
            Tu<span style={styles.naranja}>Rival</span>
          </div>
          <h2 style={styles.ctaTitulo}>¿Listo para encontrar tu rival?</h2>
          <p style={styles.ctaSub}>
            Registra tu equipo gratis en menos de 5 minutos.
            Sin tarjeta de crédito. Sin compromisos.
          </p>
          <button style={styles.btnCtaGrande} onClick={() => navigate('/registro')}>
            Registrar mi equipo gratis →
          </button>
          <div style={styles.ctaActores}>
            <span style={styles.ctaActor} onClick={() => navigate('/registro-recinto')}>
              ¿Tienes un recinto? →
            </span>
            <span style={styles.ctaActor} onClick={() => navigate('/registro-arbitro')}>
              ¿Eres árbitro? →
            </span>
            <span style={styles.ctaActor} onClick={() => navigate('/registro-tercer-tiempo')}>
              ¿Ofreces Tercer Tiempo? →
            </span>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div style={styles.footerLogo}>Tu<span style={styles.naranja}>Rival</span></div>
          <div style={styles.footerDesc}>
            La plataforma de deporte amateur de Chile.
            Fútbol · Pádel · Machalí · O'Higgins
          </div>
          <div style={styles.footerLinks}>
            {[
              { l: 'Equipos',      r: '/registro' },
              { l: 'Recintos',     r: '/registro-recinto' },
              { l: 'Árbitros',     r: '/registro-arbitro' },
              { l: 'Tercer Tiempo',r: '/registro-tercer-tiempo' },
            ].map(({ l, r }) => (
              <span key={l} style={styles.footerLink} onClick={() => navigate(r)}>{l}</span>
            ))}
          </div>
          <div style={styles.footerCopy}>© 2026 TuRival · turival.cl</div>
        </div>
      </footer>

    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#0D1117', fontFamily: "'Barlow', sans-serif" },
  naranja: { color: '#FF6B1A' },

  // NAVBAR
  nav: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 48px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    position: 'sticky', top: 0, zIndex: 100,
    background: 'rgba(13,17,23,0.96)',
    backdropFilter: 'blur(10px)',
  },
  navLogo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: 'white',
  },
  navLinks: { display: 'flex', alignItems: 'center', gap: 8 },
  navLinkBtn: {
    background: 'transparent', border: 'none',
    color: 'rgba(255,255,255,0.5)', fontSize: 14,
    cursor: 'pointer', padding: '8px 12px',
    fontFamily: "'Barlow', sans-serif",
  },
  btnNavLogin: {
    background: 'transparent',
    border: '1.5px solid rgba(255,255,255,0.15)',
    borderRadius: 10, padding: '8px 16px',
    color: 'rgba(255,255,255,0.7)', fontSize: 14,
    cursor: 'pointer', fontWeight: 600,
    fontFamily: "'Barlow', sans-serif",
  },
  btnNavRegistro: {
    background: '#FF6B1A', border: 'none',
    borderRadius: 10, padding: '8px 16px',
    color: 'white', fontSize: 14,
    cursor: 'pointer', fontWeight: 700,
    fontFamily: "'Barlow Condensed', sans-serif",
  },

  // HERO
  hero: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
    padding: '80px 48px', maxWidth: 1200,
    margin: '0 auto', gap: 60,
  },
  heroContent: { flex: 1 },
  heroBadge: {
    display: 'inline-block',
    background: 'rgba(255,107,26,0.15)', color: '#FF6B1A',
    fontSize: 13, fontWeight: 700,
    padding: '6px 14px', borderRadius: 20, marginBottom: 20,
  },
  heroTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 56, fontWeight: 800, color: 'white',
    lineHeight: 1.1, margin: '0 0 20px 0',
  },
  heroSub: {
    fontSize: 16, color: 'rgba(255,255,255,0.5)',
    lineHeight: 1.6, marginBottom: 32, maxWidth: 480,
  },
  heroBotones: { display: 'flex', gap: 12, marginBottom: 40, flexWrap: 'wrap' },
  btnHeroPrimario: {
    background: '#FF6B1A', border: 'none', borderRadius: 12,
    padding: '14px 24px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
  btnHeroSecundario: {
    background: 'transparent',
    border: '1.5px solid rgba(255,255,255,0.2)',
    borderRadius: 12, padding: '14px 24px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 700,
    color: 'rgba(255,255,255,0.6)', cursor: 'pointer',
  },
  heroStats: { display: 'flex', alignItems: 'center', gap: 0 },
  heroStatWrap: { display: 'flex', alignItems: 'center' },
  heroStat: { textAlign: 'center', padding: '0 20px' },
  heroStatNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: '#FF6B1A',
  },
  heroStatLabel: {
    fontSize: 11, color: 'rgba(255,255,255,0.3)',
    textTransform: 'uppercase', letterSpacing: '0.05em',
  },
  heroStatDiv: {
    width: 1, height: 32, background: 'rgba(255,255,255,0.1)',
  },

  // PREVIEW
  heroPreview: { flex: 0.8, flexShrink: 0 },
  previewCard: {
    background: '#161C26',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20, padding: 20, maxWidth: 340,
  },
  previewHeader: { display: 'flex', gap: 6, marginBottom: 16 },
  previewDot: { width: 10, height: 10, borderRadius: '50%' },
  previewEquipo: {
    display: 'flex', alignItems: 'center', gap: 12,
    background: '#0D1117', borderRadius: 12, padding: 12, marginBottom: 12,
  },
  previewEscudo: {
    width: 40, height: 40, borderRadius: 10, flexShrink: 0,
    background: 'linear-gradient(135deg, #FF6B1A, #1A6BFF)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 800, color: 'white',
  },
  previewNombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700, color: 'white',
  },
  previewZona: { fontSize: 11, color: 'rgba(255,255,255,0.4)' },
  previewEloWrap: { textAlign: 'right', marginLeft: 'auto' },
  previewEloNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white',
  },
  previewEloLabel: { fontSize: 10, color: 'rgba(255,255,255,0.3)' },
  previewStats: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 8, marginBottom: 12,
  },
  previewStat: {
    background: '#0D1117', borderRadius: 8,
    padding: 8, textAlign: 'center',
  },
  previewStatN: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white',
  },
  previewStatL: { fontSize: 9, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' },
  previewDesafio: {
    background: 'rgba(255,107,26,0.1)',
    border: '1px solid rgba(255,107,26,0.3)',
    borderRadius: 10, padding: 12,
  },
  previewDesafioTxt: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#FF6B1A', marginBottom: 4,
  },
  previewDesafioRival: { fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 10 },
  previewDesafioBtns: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 },
  previewBtnRechazar: {
    background: 'rgba(255,255,255,0.08)', borderRadius: 7,
    padding: 6, textAlign: 'center', fontSize: 11,
    color: 'rgba(255,255,255,0.4)', cursor: 'pointer',
  },
  previewBtnAceptar: {
    background: '#FF6B1A', borderRadius: 7, padding: 6,
    textAlign: 'center', fontSize: 11, fontWeight: 700,
    color: 'white', cursor: 'pointer',
  },

  // SECCIONES
  seccionOscura: {
    background: '#0D1117',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '80px 0',
  },
  seccionMedia: {
    background: '#161C26',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '80px 0',
  },
  inner: { maxWidth: 1100, margin: '0 auto', padding: '0 48px' },
  badge: {
    display: 'inline-block',
    background: 'rgba(26,107,255,0.15)', color: '#1A6BFF',
    fontSize: 11, fontWeight: 700, padding: '4px 12px',
    borderRadius: 20, marginBottom: 12,
    textTransform: 'uppercase', letterSpacing: '0.06em',
  },
  seccionTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 38, fontWeight: 800, color: 'white',
    margin: '0 0 32px 0', lineHeight: 1.2,
  },
  seccionSub: {
    fontSize: 15, color: 'rgba(255,255,255,0.5)',
    lineHeight: 1.6, marginBottom: 32, marginTop: -20,
  },
  grid4: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16,
  },
  grid3: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24,
  },

  // PROBLEMA
  problemaCard: {
    background: '#161C26',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 16, padding: 24,
  },
  problemaIcono: { fontSize: 32, marginBottom: 12 },
  problemaTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 700, color: 'white', marginBottom: 8,
  },
  problemaDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5,
  },

  // PASOS
  pasoCard: {
    background: '#0D1117',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 16, padding: 28, position: 'relative',
  },
  pasoNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 48, fontWeight: 800,
    color: 'rgba(255,107,26,0.25)', lineHeight: 1, marginBottom: 12,
  },
  pasoIcono: { fontSize: 28, marginBottom: 12 },
  pasoTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 700, color: 'white', marginBottom: 8,
  },
  pasoDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.6,
  },
  pasoFlecha: {
    position: 'absolute', top: '50%', right: -16,
    fontSize: 20, color: '#FF6B1A', fontWeight: 700,
    transform: 'translateY(-50%)', zIndex: 1,
  },

  // ECOSISTEMA
  ecosistemaCard: {
    background: '#0D1117',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 16, padding: 24,
    display: 'flex', flexDirection: 'column', gap: 10,
  },
  ecosistemaIcono: {
    width: 48, height: 48, borderRadius: 12,
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 22,
  },
  ecosistemaTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800,
  },
  ecosistemaDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5, flex: 1,
  },
  ecosistemaBtn: {
    background: 'transparent', border: '1.5px solid',
    borderRadius: 8, padding: '8px 12px',
    fontSize: 13, fontWeight: 700, cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },

  // ELO
  eloGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: 60, alignItems: 'center',
  },
  eloInfo: {},
  eloTexto: {
    fontSize: 14, color: 'rgba(255,255,255,0.5)',
    lineHeight: 1.7, marginBottom: 24,
  },
  eloCaracts: { display: 'flex', flexDirection: 'column', gap: 10 },
  eloCaract: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontSize: 13, color: 'rgba(255,255,255,0.7)',
  },
  eloCaractDot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#16A34A', flexShrink: 0,
  },
  eloRankingCard: {
    background: '#0D1117',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16, padding: 20,
  },
  eloRankingTitle: {
    fontSize: 10, fontWeight: 700,
    color: 'rgba(255,255,255,0.3)',
    textTransform: 'uppercase', letterSpacing: '0.06em',
    marginBottom: 14, fontFamily: "'Barlow', sans-serif",
  },
  eloRankRow: {
    display: 'flex', alignItems: 'center',
    gap: 10, padding: '8px', marginBottom: 4,
  },
  eloRankPos: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700,
    color: 'rgba(255,255,255,0.3)', minWidth: 20,
  },
  eloRankCrest: {
    width: 32, height: 32, borderRadius: 7,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 10, fontWeight: 800, color: 'white',
  },
  eloRankNombre: {
    flex: 1, fontSize: 13,
    fontFamily: "'Barlow', sans-serif",
  },
  tuBadge: {
    background: '#1A6BFF', color: 'white',
    fontSize: 9, fontWeight: 700,
    padding: '1px 6px', borderRadius: 10,
    fontFamily: "'Barlow', sans-serif", marginLeft: 4,
  },
  eloRankElo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 800, color: '#FF6B1A',
  },

  // DEPÓSITO Y AUSENTISMO
  ausentismoExplicacion: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14, padding: '20px 24px', marginBottom: 32,
  },
  ausentismoTexto: {
    fontSize: 14, color: 'rgba(255,255,255,0.5)',
    lineHeight: 1.7, marginBottom: 10,
    fontFamily: "'Barlow', sans-serif",
  },
  garantiaCard: {
    background: '#161C26',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 16, padding: 28, textAlign: 'center',
  },
  garantiaIcono: {
    width: 48, height: 48, borderRadius: '50%',
    border: '2px solid', margin: '0 auto 16px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 20, fontWeight: 700,
  },
  garantiaTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 700, color: 'white', marginBottom: 8,
  },
  garantiaDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.5,
  },

  // EVALUACIONES
  evalCard: {
    background: '#0D1117',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 16, padding: 24, textAlign: 'center',
  },
  evalIcono: { fontSize: 32, marginBottom: 12 },
  evalTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 700, color: 'white', marginBottom: 8,
  },
  evalDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    lineHeight: 1.5, marginBottom: 16,
  },
  evalBarra: {
    height: 4, background: 'rgba(255,255,255,0.08)',
    borderRadius: 4, overflow: 'hidden',
  },
  evalBarraFill: {
    height: '100%', background: '#FF6B1A', borderRadius: 4,
  },
  evalNota: {
    marginTop: 24, background: 'rgba(26,107,255,0.1)',
    border: '1px solid rgba(26,107,255,0.2)',
    borderRadius: 12, padding: '12px 20px',
    fontSize: 13, color: '#93C5FD',
    fontFamily: "'Barlow', sans-serif",
    textAlign: 'center', lineHeight: 1.5,
  },

  // CTA
  ctaSeccion: {
    padding: '100px 48px',
    background: 'linear-gradient(135deg, rgba(255,107,26,0.2) 0%, rgba(26,107,255,0.2) 100%)',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    textAlign: 'center',
  },
  ctaInner: { maxWidth: 600, margin: '0 auto' },
  ctaLogo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 36, fontWeight: 800, color: 'white', marginBottom: 16,
  },
  ctaTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 44, fontWeight: 800, color: 'white',
    margin: '0 0 16px 0',
  },
  ctaSub: {
    fontSize: 16, color: 'rgba(255,255,255,0.6)',
    lineHeight: 1.6, marginBottom: 32,
  },
  btnCtaGrande: {
    background: '#FF6B1A', border: 'none',
    borderRadius: 14, padding: '16px 32px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800, color: 'white',
    cursor: 'pointer', marginBottom: 24, display: 'block',
    margin: '0 auto 24px',
  },
  ctaActores: {
    display: 'flex', justifyContent: 'center',
    gap: 24, flexWrap: 'wrap',
  },
  ctaActor: {
    fontSize: 14, color: 'rgba(255,255,255,0.6)',
    cursor: 'pointer', fontWeight: 600,
    textDecoration: 'underline',
  },

  // FOOTER
  footer: {
    background: '#080D12',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '40px 48px',
  },
  footerInner: {
    maxWidth: 1100, margin: '0 auto',
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', flexWrap: 'wrap', gap: 16,
  },
  footerLogo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 24, fontWeight: 800, color: 'white',
  },
  footerDesc: {
    fontSize: 12, color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif",
  },
  footerLinks: { display: 'flex', gap: 20 },
  footerLink: {
    fontSize: 12, color: 'rgba(255,255,255,0.4)',
    cursor: 'pointer', fontFamily: "'Barlow', sans-serif",
  },
  footerCopy: {
    fontSize: 11, color: 'rgba(255,255,255,0.2)',
    fontFamily: "'Barlow', sans-serif",
  },
};